const LineTaxSummary = require('@/lib/Tax/LineTaxSummary');
const TaxRateLetters = require('@/lib/Tax/TaxRateLetters');
const TaxSummaryGroup = require('@/lib/Tax/TaxSummaryGroup');
const { sumTaxSummaryGroups } = require('@/lib/Tax/index');

/**
 * This represents the total tax for an overall booking, or an individual order depending on how it is loaded.
 * This is the combination of tax for all lines in the booking/order.
 */
class TaxSummary {
    constructor() {
        /**
         * @type {TaxSummaryGroup[]}
         */
        this.taxSummaryGroups = null;

        /**
         * The list of tax summary groups re-grouped only by the taxRate.
         *
         * @type {TaxSummaryGroup[]}
         */
        this.taxSummaryGroupsByTaxRate = [];

        /**
         * @type {TaxSummaryGroup}
         */
        this.taxSummarySumGroup = null;

        /**
         * @type {LineTaxSummary[]}
         */
        this.lines = [];

        /**
         * @type {TaxRateLetters}
         */
        this.taxRateLetters = new TaxRateLetters();
    }

    getHydrationMap() {
        return {
            taxSummaryGroups: {
                // The array of groups is just called taxSummary from the API.
                field: ['taxSummaryGroups', 'taxSummary'],
                modelCollection: TaxSummaryGroup,
            },
            lines: {
                modelCollection: LineTaxSummary,
            },
        };
    }

    afterHydration() {
        this.taxSummarySumGroup = sumTaxSummaryGroups(this.taxSummaryGroups);
    }

    /**
     * @param {number} ordersItemsID
     *
     * @return {LineTaxSummary|null}
     */
    getLineByOrdersItemsID(ordersItemsID) {
        return this.lines.find((line) => {
            return line.ordersItemsIDs.includes(ordersItemsID);
        }) || null;
    }
}

module.exports = TaxSummary;
